type TJwtPayload = Record<string, unknown> & {
  exp?: number;
};

const TOKEN_EXPIRATION_BUFFER_SECONDS = 30;
const WEB_REQUIRED_CLAIMS = ["sub", "iat", "exp", "extension_clientId"];
const MOBILE_REQUIRED_CLAIMS = ["sub", "iat", "exp"];

const decodeJwtPayload = (token: string): TJwtPayload => {
  const parts = token.split(".");
  if (parts.length !== 3) throw new Error("Formato de token invalido");

  const base64Url = parts[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");

  return JSON.parse(atob(padded)) as TJwtPayload;
};

export const getTokenExpirationTime = (token: string): number | null => {
  try {
    const expiration = decodeJwtPayload(token).exp;

    return typeof expiration === "number" ? expiration * 1000 : null;
  } catch {
    return null;
  }
};

export const isTokenValid = (token: string, isMobileAuth: boolean) => {
  if (!token) return false;

  try {
    const payload = decodeJwtPayload(token);
    const now = Date.now() / 1000;
    const expiration = payload.exp;

    if (typeof expiration !== "number" || now >= expiration - TOKEN_EXPIRATION_BUFFER_SECONDS) {
      return false;
    }

    const requiredClaims = isMobileAuth ? MOBILE_REQUIRED_CLAIMS : WEB_REQUIRED_CLAIMS;

    return requiredClaims.every((claim) => Boolean(payload[claim]));
  } catch (error: unknown) {
    console.error("Erro ao validar token:", error);
    return false;
  }
};
